import PrefixEnum from '../prefixes'

export default Object.freeze({
    'labrantfit.gymondo.fitness': PrefixEnum.LABRANT,
    'labrantfit.com': PrefixEnum.LABRANT,
    'www.labrantfit.com': PrefixEnum.LABRANT,
})
